function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgLayoutLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M9.503 10.505h5m-5-8.01h5m-5 11.01h5m-5-8.01h5M2.059 9.497h3.889c.306 0 .555.248.555.555v3.89a.556.556 0 0 1-.555.555h-3.89a.556.556 0 0 1-.555-.556v-3.889c0-.306.249-.555.556-.555Zm-.004-8.002h3.889c.307 0 .555.25.555.556V5.94a.556.556 0 0 1-.555.555h-3.89A.556.556 0 0 1 1.5 5.94V2.05c0-.307.249-.556.556-.556Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));
export default SvgLayoutLeft;